
import { computed, defineComponent, PropType } from 'vue'
import { EnvFeaturesEnum } from '@invivodf/front-seller-feature-flipping'
import { IUseDiscountInput } from '../../composables/useDiscountInput'

export default defineComponent({
  name: 'CDiscountFlashSaleInput',
  props: {
    input: {
      type: Object as PropType<IUseDiscountInput>,
      required: true,
    },
  },
  setup() {
    return {
      isFlashSaleEnabled: computed(() => window.env[EnvFeaturesEnum.DISCOUNT_FLASH_SALE_FEATURE] === 'yes'),
    }
  },
})
